import "./ThankyouPage.css";
// import IndLogo from "../../assest/img/kenyalanding/logo-transparent.png";
import IndLogo from "../../assest/img/Dubai Property-Expo-logo.png";
import { useEffect } from "react";

export default function ThankyouPageDubai() {
  // SEO Tag
  useEffect(() => {
    // Check if script already added
    if (document.querySelector('script[data-fbq="complete-registration"]'))
      return;

    const script = document.createElement("script");
    script.setAttribute("data-fbq", "complete-registration");
    script.innerHTML = `fbq('track', 'CompleteRegistration');`;

    document.body.appendChild(script); // <== Directly into body
  }, []);
  return (
    <>
      <section class="thank-you-wrapper">
        <div class="container">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div class="thank-you-page-logo">
                <a href="/">
                  <img src={IndLogo} class="img-fluid logo-img" alt="Logo" />
                </a>
              </div>
              <div class="thank-you-page-content">
                <h1>Thank You!</h1>
                <p>
                  We're grateful for your interest. Feel free to reach out if
                  you have any questions or need assistance.
                </p>
                <a href="/dubai" class="btn-register">
                  {" "}
                  Go back to Homepage{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
